export default __webpack_public_path__ + "static/sheetstrip-88299d765593117eb55bd013f51d25d8.png";